import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service'
import { ActivatedRoute, Router } from '@angular/router';

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/TimesheetBilling/timesheetBilling.html'
})


export class TimesheetBillingComponent implements OnInit {
    constants: Constants;
    userDetail: any;
    projectList: any = [];
    siteUserItems: any = [];
    public showLoader = false;
    selectAll: any = false;
    userList: any = [];
    selfuser: boolean = true;
    selectedTimesheetItems: string = "";
    timesheetBillingItems = [];
    timesheetDetailBillingItems = [];
    IsDisabled: boolean = true;
    reportFile: any;
    public currencies: any = [];
    public Customers: any = [];

    filter: any = { 'ProjectId': "", 'FromDate': moment().format('DD/MM/YYYY'), 'ToDate': moment().format('DD/MM/YYYY'), 'TeamId': "", 'UserId': "",'CustomerId': "",'IsBilled':"1" };

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private datePipe: DatePipe, private route: ActivatedRoute, private _route: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        //  this.filter={'TeamId': this.timesheetItems.TeamID, 'UserId': this.timesheetItems.SiteUserId}
        this.filter.TeamId = "";
    }

    ngOnInit() {

        var dt = new Date();
        var month = new Array();
        month[0] = "01";
        month[1] = "02";
        month[2] = "03";
        month[3] = "04";
        month[4] = "05";
        month[5] = "06";
        month[6] = "07";
        month[7] = "08";
        month[8] = "09";
        month[9] = "10";
        month[10] = "11";
        month[11] = "12";
        var mth = month[dt.getMonth()];
        var yr = dt.getFullYear();
        var newDate = '01/' + mth + '/' + yr;
        this.filter.FromDate = newDate;
        this.GetTimesheetBillingData(false);
        this.getCurrency();
        this.GetUserListbyproj();
        this.GetProjectList(0);
        this.getCustomer();

    }

    ngAfterViewInit() {


        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });

        $("#show-filter").click(function () { $(".filter-form").slideToggle() });


        $('#userIdFilter').select2().val("").trigger("change");
        $('#userIdFilter').on(
            'change',
            (e) => this.filter.UserId = jQuery(e.target).val()
        );

    }

    GetUserListbyproj() {
        //   this.filter.UserId="";
        var teamId = this.userDetail.TeamID;

        this.showLoader = true;
        this._httpService.ajaxPost('Users/GetUsers', {
            "IsActive": 1,
            "Team": this.userDetail.TeamID,
            "UserId": this.userDetail.SiteUserId
        }).subscribe(
            data => {
                this.userList = data["Users"];
                $(".project").val('').selectpicker('refresh');
            },
            err => {
                console.log("GetUserList Failed");
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    GetProjectList(val) {
        this.filter.ProjectId = "";
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0 && val == "") {
            UserId = this.userDetail.SiteUserId;
            TeamId = this.userDetail.TeamID;
        }
        else {
            UserId = val;
        }
        this.showLoader = true;
        this._httpService.ajaxPost("Project/GetAssignedProject",
            { "ProjectId": 0, "OwnerTeamId": TeamId, "ProjectType": 0, "Status": 0, "UserId": UserId }).subscribe(
                data => {
                    this.projectList = data["ProjectList"];
                },
                err => {
                    console.log("GetProjectList Failed");
                    this.showLoader = false;
                },
                () => {
                    this.showLoader = false;
                }
            );
    }


    GetTimesheetBillingData(flag: boolean) {
        this.showLoader = true;
        this.selectAll = false;
        this.selfuser = flag;
        var UserId = 0
        if (this.filter.UserId == "") {
            //UserId = this.userDetail.SiteUserId
        }
        else {
            UserId = this.filter.UserId
        }
        var TeamId = "0"
        if (this.filter.TeamId == "") {
            //TeamId = this.userDetail.TeamID
            TeamId = this.constants.TeamId;
        }
        else {
            TeamId = this.filter.TeamId
        }
        this._httpService.ajaxPost("TimesheetBilling/GetTimesheetBillingData",
            {
                "UserId": UserId,
                "ProjectId": this.filter.ProjectId,
                "FromDate": this.filter.FromDate,
                "ToDate": this.filter.ToDate,
                "TeamId": TeamId,
                "TimesheetProcessId": this.selectedTimesheetItems,
                "CustomerId":this.filter.CustomerId,
                "LoggedInUser": this.userDetail.SiteUserId
            }).subscribe(

                data => {
                    this.timesheetBillingItems = data["TimesheetBillingList"];
                    // this.timesheetItems.forEach(element => {
                    //     element.TimeSheet_Date = this.datePipe.transform(element.TimeSheet_Date, "dd-MM-yyyy");
                    // });
                    if(this.filter.IsBilled==1){
                       
          
                        this.timesheetBillingItems= this.timesheetBillingItems.filter(m1 => m1.Bill_Id !=null);
                    }
                    if(this.filter.IsBilled==2){
                       
          
                        this.timesheetBillingItems= this.timesheetBillingItems.filter(m1 => m1.Bill_Id == null);
                    }
                },
                err => {
                    console.log("GetProcessTimesheetList Failed");
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);

                },
                () => {
                    this.showLoader = false;
                });
    }

    GetTimesheetBillingDetailData(data) {
        this.showLoader = true;
        this._httpService.ajaxPost("TimesheetBilling/GetTimesheetBillingDetailData",
            {
                "TimesheetProcessId": data.Process_Id
            }).subscribe(

                data => {
                    this.timesheetDetailBillingItems = data["TimesheetDetailBillingList"];
                    // this.timesheetItems.forEach(element => {
                    //     element.TimeSheet_Date = this.datePipe.transform(element.TimeSheet_Date, "dd-MM-yyyy");
                    // });
                    $('#processBillDetailPopup').modal('show');
                },
                err => {
                    console.log("GetProcess Detail TimesheetList Failed");
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);

                },
                () => {
                    this.showLoader = false;
                });
    }

    onSelectAll() {
        if (this.selectAll) {
            this.timesheetBillingItems.forEach(element => {

                element.IsChecked = true;

            });
        } else {
            this.timesheetBillingItems.forEach(element => {

                element.IsChecked = false;

            });
        }
        this.onSelectInventory();
    }

    onSelectInventory() {
        if (this.timesheetBillingItems.filter(x => x.IsChecked == true).length > 0) {
            this.IsDisabled = false;
        } else {
            this.IsDisabled = true;
        }

        if (this.timesheetBillingItems.filter(x => x.IsChecked != true).length > 0)
            this.selectAll = false;
        else
            this.selectAll = true;
    }

    GetBillableTime(data) {
        data.OldAdjustment = data.BillableTime - data.TimeSpent;
        data.BillableTime = data.TimeSpent + Number(data.Adjustment);
        if (data.BillableTime < 0) {
            this._sharedService.ShowMessage("error|Please enter Valid time.");
            data.BillableTime = data.TimeSpent;
            data.Adjustment = 0;
        }
    }

    ExportDataInExcel() {
        this.showLoader = true;
        this.selectedTimesheetItems = "";
        this.timesheetBillingItems.forEach(element => {
            if (element.IsChecked == true) {
                this.selectedTimesheetItems = element.Process_Id + ',' + this.selectedTimesheetItems;
            }
        });
        this.selectedTimesheetItems = this.selectedTimesheetItems.slice(0, -1)
        if (this.selectedTimesheetItems == "") {
            this._sharedService.ShowMessage("error|Select atleast one record.");
            this.showLoader = false;
            return;
        }
        var UserId = 0
        if (this.filter.UserId == "") {
            //UserId = this.userDetail.SiteUserId
        }
        else {
            UserId = this.filter.UserId
        }
        var TeamId = "0"
        if (this.filter.TeamId == "") {
            //TeamId = this.userDetail.TeamID
            TeamId = this.constants.TeamId;
        }
        else {
            TeamId = this.filter.TeamId
        }
        this._httpService.ajaxPost("TimesheetBilling/ExportTimesheetBillData",
            {
                "UserId": UserId,
                "ProjectId": this.filter.ProjectId,
                "FromDate": this.filter.FromDate,
                "ToDate": this.filter.ToDate,
                "TeamId": TeamId,
                "TimesheetProcessId": this.selectedTimesheetItems,
                "CustomerId":this.filter.CustomerId,
                "LoggedInUser": this.userDetail.SiteUserId
            }).subscribe(

                data => {
                    this.reportFile = data["ReportFile"];
                    window.location.href = this.reportFile;
                    this.selectedTimesheetItems =  "";

                },
                err => {
                    console.log("Export timesheet billing Failed");
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);

                },
                () => {
                    this.showLoader = false;
                });
    }

    AddTimesheetForProcess(data, index) {

        let objItem: any = [];

        data.OldAdjustment = data.Adjustment;
        let objRecord: any = {};
        objRecord.Process_Id = data.Process_Id;
        objRecord.UserId = data.UserId;
        objRecord.ProjectId = data.ProjectId;
        objRecord.TimeSpent = data.TimeSpent;
        objRecord.Adjustment = data.Adjustment == "" ? 0 : data.Adjustment;
        objRecord.TimeSheetIdString = '';
        objRecord.Created_By = this.userDetail.SiteUserId;
        objRecord.FromDate = this.filter.FromDate,
            objRecord.ToDate = this.filter.ToDate,
            objRecord.UserRate = data.EmployeeCost == "" ? 0 : data.EmployeeCost;
        objRecord.Currency = data.EmployeeCostCurrency == "" ? 0 : data.EmployeeCostCurrency;
        objItem.push(objRecord);


        console.log(JSON.stringify(objItem));
        if (objItem.length > 0) {
            let objTimesheet: any = { "TimesheetProcessList": objItem };
            this._httpService.ajaxPost('TimesheetProcess/AddTimesheetForProcess', objTimesheet).subscribe(
                data => {

                    var msg = data["Status"].Message.split('|');
                    if (msg.length > 1) {
                        // var propCancelName = '#CancelRecord' + index;
                        // var propAdjName = '#Adjustment' + index;
                        // var propSaveName = '#SaveRecord' + index;
                        // $(propAdjName).css({ "background-color": "#D3D3D3" });
                        // $(propAdjName).attr('disabled', 'disabled');
                        // $(propSaveName).attr('hidden', 'true');
                        // $(propCancelName).attr('hidden', 'true');

                        //if (message[0] == "warning") {
                        //    //vm.isWarning = true;
                        //}
                        msg[0] = msg[0].toLowerCase();
                        //this._toasterService.pop(msg[0], msg[1]);
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }
                    else {
                        //this._toasterService.pop('success', msg);
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }
                }
            );
        }
        else {
            this._sharedService.ShowMessage("error|Enter atleast one record");
        }

    }

    SaveProcessedBills() {

        let objItem: any = [];
        var count = this.timesheetBillingItems.filter(element => element.IsChecked == true).length;
        this.timesheetBillingItems.forEach(data => {
            let objRecord: any = {};
            if (count == 0 || data.IsChecked == true) {
                objRecord.Process_Id = data.Process_Id;
                objRecord.UserId = data.UserId;
                objRecord.ProjectId = data.ProjectId;
                objRecord.TimeSpent = data.TimeSpent;
                objRecord.Adjustment = data.Adjustment == "" ? 0 : data.Adjustment;
                objRecord.TimeSheetIdString = '';
                objRecord.Created_By = this.userDetail.SiteUserId;
                objRecord.FromDate = this.filter.FromDate,
                    objRecord.ToDate = this.filter.ToDate,

                    objRecord.UserRate = data.EmployeeCost == "" ? 0 : data.EmployeeCost;
                objRecord.Currency = data.EmployeeCostCurrency == "" ? 0 : data.EmployeeCostCurrency;
                objRecord.Bill_Id = data.Bill_Id;
                objItem.push(objRecord);
            }

        });
        if (this.validateSaveData(objItem)) {
            console.log(JSON.stringify(objItem));
            if (objItem.length > 0) {
                let objTimesheet: any = { "TimesheetProcessList": objItem };
                this._httpService.ajaxPost('TimesheetProcess/AddTimesheetForProcess', objTimesheet).subscribe(
                    data => {

                        var msg = data["Status"].Message.split('|');
                        if (msg.length > 1) {

                            //if (message[0] == "warning") {
                            //    //vm.isWarning = true;
                            //}
                            msg[0] = msg[0].toLowerCase();
                            //this._toasterService.pop(msg[0], msg[1]);
                            this._sharedService.ShowMessage(data["Status"].Message);
                        }
                        else {
                            //this._toasterService.pop('success', msg);
                            this._sharedService.ShowMessage(data["Status"].Message);
                        }
                    }
                );
            }
            else {
                this._sharedService.ShowMessage("error|Enter atleast one record");
            }
        }
    }

    EditTimesheet(index) {
        // var propAdjName = '#Adjustment' + index;
        // var propSaveName = '#SaveRecord' + index;
        // var propCancelName = '#CancelRecord' + index;
        // $(propAdjName).css({ "background-color": "white" });
        // $(propAdjName).removeAttr('disabled');
        // $(propSaveName).removeAttr('hidden');
        // $(propCancelName).removeAttr('hidden');
    }

    CancelSave(data, index) {
        // var propAdjName = '#Adjustment' + index;
        // var propSaveName = '#SaveRecord' + index;
        // var propCancelName = '#CancelRecord' + index;
        // $(propSaveName).attr('hidden', 'true');
        // $(propCancelName).attr('hidden', 'true');
        // $(propAdjName).css({ "background-color": "#D3D3D3" });
        // $(propAdjName).attr('disabled', 'disabled');
        if (data.OldAdjustment != undefined) {
            data.BillableTime = data.TimeSpent + Number(data.OldAdjustment);
            data.Adjustment = data.OldAdjustment;
        }

    }


    public getCurrency() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["Currency"] }).subscribe(
            data => {
                this.currencies = data["Parameter"];
                console.log(this.currencies);

            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false
            }
        );
    }

    SaveInvoice() {
        if (this.validateData()) {
            this.SaveProcessedBills();
            let objRecord: any = {};
            let BillIdString: any = "";
            let TotalAmt: any = 0;
            this.timesheetBillingItems.forEach(data => {
                if (data.IsChecked == true) {
                    var billableTime = Number(data.TimeSpent) + Number(data.Adjustment);
                    var billableHours = billableTime / 60;
                    var Amount = billableHours * Number(data.EmployeeCost);
                    TotalAmt = TotalAmt + Amount;
                    objRecord.totalAmount
                    BillIdString = BillIdString + data.Process_Id + ",";
                }
            });

            objRecord.Bill_Id = 0;
            objRecord.CustomerId = this.timesheetBillingItems.filter(z=>z.IsChecked == true)[0].Customer_Id;
            objRecord.Amount = TotalAmt;
            objRecord.Discount = 0;
            objRecord.VATRate = 0;
            objRecord.PaymentStatus = false;
            objRecord.AccountingRef = 0;
            objRecord.Currency = this.timesheetBillingItems.filter(z=>z.IsChecked == true)[0].EmployeeCostCurrency;
            objRecord.ProcessBillIdString = BillIdString;
            objRecord.CreatedBy = this.userDetail.SiteUserId;


            console.log(JSON.stringify(objRecord));

            this._httpService.ajaxPost('TimesheetBilling/AddUpdateTimesheetBill', objRecord).subscribe(
                data => {

                    var msg = data["Status"].Message.split('|');
                    if (msg.length > 1) {

                        msg[0] = msg[0].toLowerCase();
                        //this._toasterService.pop(msg[0], msg[1]);
                        this.GetTimesheetBillingData(false);
                        var id = data["newBillId"];
                        if(id != null && id > 0)
                        {
                        this._route.navigateByUrl("/invoiceEdit;BillId="+id); 
                        }
                       // this._sharedService.ShowMessage(data["Status"].Message);
                    }
                    else {
                        //this._toasterService.pop('success', msg);
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);

                }
            );
        }
    }

    validateData() {
        var flag = true;
        var isRecordSelected = false;
        this.timesheetBillingItems.forEach(data => {
            if (data.IsChecked == true && flag == true) {
                isRecordSelected = true;
                if (data.EmployeeCost == 0 || data.EmployeeCost == "" || data.EmployeeCost == null) {
                    flag = false;
                    this._sharedService.ShowMessage("error|Select Cost for each Executive.");
                    return;
                }
                if (data.EmployeeCostCurrency == 0 || data.EmployeeCostCurrency == "" || data.EmployeeCostCurrency == null) {
                    flag = false;
                    this._sharedService.ShowMessage("error|Select Currency for each Executive.");
                    return;
                }
                if (data.Bill_Id != null && data.Bill_Id > 0) {
                    flag = false;
                    this._sharedService.ShowMessage("error|Invoice is already generated for selected record.");
                    return;
                }
            }
        });


        if (isRecordSelected == false) {
            flag = false;
            this._sharedService.ShowMessage("error|Select atleast one record");
        }
        else {
            var selectRecordList = this.timesheetBillingItems.filter(x => x.IsChecked == true);
            var CurrencyList = Array.from(new Set(selectRecordList.map((item: any) => item.EmployeeCostCurrency)));
            var CustomerList = Array.from(new Set(selectRecordList.map((item: any) => item.Customer_Id)));
          //  var ProjectList = Array.from(new Set(selectRecordList.map((item: any) => item.ProjectId)));
            if (CustomerList.length > 1 || CurrencyList.length > 1) {
                flag = false;
                this._sharedService.ShowMessage("error|Selected records must have same Customer and Currency.");
            }
        }
        return flag;
    }

    validateSaveData(objItem) {
        var flag = true;
        objItem.forEach(data => {
            if ((data.Bill_Id != null && data.Bill_Id > 0) && flag == true) {
                flag = false;
                this._sharedService.ShowMessage("error|Can not edit records for which invoice is generated");
                return;
            }
        });
        return flag;
    }

    public getCustomer() {
        this.showLoader = true;
        this._httpService.ajaxPost('Customer/GetCustomer', { "CustomerId": 0, "CountryId": 0, "CustomerStatus": true }).subscribe(
            data => {
                this.Customers = data["CustomerList"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false
            }
        );
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/TimesheetBilling/timesheetBilling.component.ts
 **/